/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetClientDto } from './GetClientDto';
import {
    GetClientDtoFromJSON,
    GetClientDtoFromJSONTyped,
    GetClientDtoToJSON,
} from './GetClientDto';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';
import type { GetProjectDto } from './GetProjectDto';
import {
    GetProjectDtoFromJSON,
    GetProjectDtoFromJSONTyped,
    GetProjectDtoToJSON,
} from './GetProjectDto';
import type { SignaturePositionSchemaDto } from './SignaturePositionSchemaDto';
import {
    SignaturePositionSchemaDtoFromJSON,
    SignaturePositionSchemaDtoFromJSONTyped,
    SignaturePositionSchemaDtoToJSON,
} from './SignaturePositionSchemaDto';

/**
 * 
 * @export
 * @interface GetContractDto
 */
export interface GetContractDto {
    /**
     * 
     * @type {string}
     * @memberof GetContractDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetContractDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetContractDto
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractDto
     */
    status: GetContractDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetContractDto
     */
    additionalEmailContent: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractDto
     */
    emailContent: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractDto
     */
    emailUid: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractDto
     */
    emailFrom: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractDto
     */
    contractorEmail: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetContractDto
     */
    notSendAutomatically: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetContractDto
     */
    sentByHand: boolean;
    /**
     * 
     * @type {GetProjectDto}
     * @memberof GetContractDto
     */
    project: GetProjectDto;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetContractDto
     */
    responsibleOwner: GetEmployeeDto;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetContractDto
     */
    authorizedOwner: GetEmployeeDto;
    /**
     * 
     * @type {GetClientDto}
     * @memberof GetContractDto
     */
    client: GetClientDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetContractDto
     */
    active: boolean;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetContractDto
     */
    creator: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetContractDto
     */
    creationTs: Date;
    /**
     * 
     * @type {Array<SignaturePositionSchemaDto>}
     * @memberof GetContractDto
     */
    signaturePositions?: Array<SignaturePositionSchemaDto> | null;
    /**
     * 
     * @type {string}
     * @memberof GetContractDto
     */
    reasonUnsigning: string;
    /**
     * 
     * @type {Date}
     * @memberof GetContractDto
     */
    waitingSignDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetContractDto
     */
    signDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetContractDto
     */
    unsignDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetContractDto
     */
    amountUnsettled?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetContractDto
     */
    signedOutsidePok: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetContractDto
     */
    tv: boolean;
}


/**
 * @export
 */
export const GetContractDtoStatusEnum = {
    Entered: 'Entered',
    WaitingForSigning: 'WaitingForSigning',
    Signed: 'Signed',
    Unsigned: 'Unsigned',
    Sent: 'Sent'
} as const;
export type GetContractDtoStatusEnum = typeof GetContractDtoStatusEnum[keyof typeof GetContractDtoStatusEnum];


/**
 * Check if a given object implements the GetContractDto interface.
 */
export function instanceOfGetContractDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "additionalEmailContent" in value;
    isInstance = isInstance && "emailContent" in value;
    isInstance = isInstance && "emailUid" in value;
    isInstance = isInstance && "emailFrom" in value;
    isInstance = isInstance && "contractorEmail" in value;
    isInstance = isInstance && "notSendAutomatically" in value;
    isInstance = isInstance && "sentByHand" in value;
    isInstance = isInstance && "project" in value;
    isInstance = isInstance && "responsibleOwner" in value;
    isInstance = isInstance && "authorizedOwner" in value;
    isInstance = isInstance && "client" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "creator" in value;
    isInstance = isInstance && "creationTs" in value;
    isInstance = isInstance && "reasonUnsigning" in value;
    isInstance = isInstance && "signedOutsidePok" in value;
    isInstance = isInstance && "tv" in value;

    return isInstance;
}

export function GetContractDtoFromJSON(json: any): GetContractDto {
    return GetContractDtoFromJSONTyped(json, false);
}

export function GetContractDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContractDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'number': json['number'],
        'amount': json['amount'],
        'status': json['status'],
        'additionalEmailContent': json['additionalEmailContent'],
        'emailContent': json['emailContent'],
        'emailUid': json['emailUid'],
        'emailFrom': json['emailFrom'],
        'contractorEmail': json['contractorEmail'],
        'notSendAutomatically': json['notSendAutomatically'],
        'sentByHand': json['sentByHand'],
        'project': GetProjectDtoFromJSON(json['project']),
        'responsibleOwner': GetEmployeeDtoFromJSON(json['responsibleOwner']),
        'authorizedOwner': GetEmployeeDtoFromJSON(json['authorizedOwner']),
        'client': GetClientDtoFromJSON(json['client']),
        'active': json['active'],
        'creator': GetEmployeeDtoFromJSON(json['creator']),
        'creationTs': (new Date(json['creationTs'])),
        'signaturePositions': !exists(json, 'signaturePositions') ? undefined : (json['signaturePositions'] === null ? null : (json['signaturePositions'] as Array<any>).map(SignaturePositionSchemaDtoFromJSON)),
        'reasonUnsigning': json['reasonUnsigning'],
        'waitingSignDate': !exists(json, 'waitingSignDate') ? undefined : (new Date(json['waitingSignDate'])),
        'signDate': !exists(json, 'signDate') ? undefined : (new Date(json['signDate'])),
        'unsignDate': !exists(json, 'unsignDate') ? undefined : (new Date(json['unsignDate'])),
        'amountUnsettled': !exists(json, 'amountUnsettled') ? undefined : json['amountUnsettled'],
        'signedOutsidePok': json['signedOutsidePok'],
        'tv': json['tv'],
    };
}

export function GetContractDtoToJSON(value?: GetContractDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'number': value.number,
        'amount': value.amount,
        'status': value.status,
        'additionalEmailContent': value.additionalEmailContent,
        'emailContent': value.emailContent,
        'emailUid': value.emailUid,
        'emailFrom': value.emailFrom,
        'contractorEmail': value.contractorEmail,
        'notSendAutomatically': value.notSendAutomatically,
        'sentByHand': value.sentByHand,
        'project': GetProjectDtoToJSON(value.project),
        'responsibleOwner': GetEmployeeDtoToJSON(value.responsibleOwner),
        'authorizedOwner': GetEmployeeDtoToJSON(value.authorizedOwner),
        'client': GetClientDtoToJSON(value.client),
        'active': value.active,
        'creator': GetEmployeeDtoToJSON(value.creator),
        'creationTs': (value.creationTs.toISOString()),
        'signaturePositions': value.signaturePositions === undefined ? undefined : (value.signaturePositions === null ? null : (value.signaturePositions as Array<any>).map(SignaturePositionSchemaDtoToJSON)),
        'reasonUnsigning': value.reasonUnsigning,
        'waitingSignDate': value.waitingSignDate === undefined ? undefined : (value.waitingSignDate.toISOString()),
        'signDate': value.signDate === undefined ? undefined : (value.signDate.toISOString()),
        'unsignDate': value.unsignDate === undefined ? undefined : (value.unsignDate.toISOString()),
        'amountUnsettled': value.amountUnsettled,
        'signedOutsidePok': value.signedOutsidePok,
        'tv': value.tv,
    };
}

